import { TextInput } from 'flowbite-react';
import React, { useEffect, useMemo, useState } from 'react';
import Downshift from 'downshift';
import cx from 'classnames';
import { GetAllRecruitersOfCompanyAPIResponse } from 'types';
import { useUserContext } from 'src/context/UserProvider';

interface Props {
	onChange: (value: string) => void;
	companyId: string;
	recruitersData?: GetAllRecruitersOfCompanyAPIResponse;
	textInputStyle: {
		[key: string]: string;
	};
	value?: string;
}

function HRSelection({ onChange, companyId, textInputStyle, recruitersData, value }: Props) {
	const { user } = useUserContext();
	const [typedHREmail, setTypedHREmail] = useState('');
	const items = useMemo(() => {
		const recruiters =
			recruitersData?.recruiters?.filter(c => c.email !== user?.email)?.map(c => ({ name: c.email, value: c.email })) ||
			[];
		const items: { name: string; value: string }[] = recruiters.filter(r => r.value.includes(typedHREmail));
		if (!recruiters.some(i => i.value === typedHREmail) && typedHREmail) {
			items.push({
				name: typedHREmail,
				value: typedHREmail,
			});
		}
		return items;
	}, [recruitersData?.recruiters, typedHREmail]);

	useEffect(() => {
		setTypedHREmail(value || '');
	}, [value]);
	return (
		<div>
			<Downshift
				inputValue={typedHREmail}
				onInputValueChange={inputValue => setTypedHREmail(inputValue)}
				itemToString={item => (item ? item.name : '')}
				onChange={selection => onChange(selection.value)}
			>
				{({
					selectItem,
					getInputProps,
					getRootProps,
					getMenuProps,
					highlightedIndex,
					isOpen,
					selectedItem,
					getItemProps,
				}) => {
					const { onChange, onBlur, ...inputProps } = getInputProps({
						className: 'flex-grow',
						id: 'company',
					});
					return (
						<div className="relative">
							<div className="flex shadow-sm gap-0.5" {...getRootProps({}, { suppressRefError: true })}>
								<TextInput
									placeholder="xcd@mail.com"
									onBlur={e => {
										selectItem({ name: typedHREmail, value: typedHREmail });
										onBlur && onBlur(e);
									}}
									onChange={e => {
										onChange && onChange(e);
									}}
									{...inputProps}
									style={textInputStyle}
								/>
								{/* <button
                                    aria-label={'toggle menu'}
                                    className="px-2"
                                    type="button"
                                    {...getToggleButtonProps()}
                                >
                                    {isOpen ? <>&#8593;</> : <>&#8595;</>}
                                </button> */}
							</div>
							<ul
								className={`absolute w-72 dark:bg-black bg-[#fff] mt-1 shadow-md max-h-80 overflow-scroll p-0 z-10 ${
									!(isOpen && items.length) && 'hidden'
								}`}
								{...getMenuProps()}
							>
								{items.map((item, index) => (
									<li
										className={cx(
											highlightedIndex === index && 'bg-blue-300',
											selectedItem === item && 'font-bold',
											'py-2 px-3 shadow-sm flex flex-col',
										)}
										{...getItemProps({
											key: item.value,
											index,
											item,
										})}
									>
										<span>{item.name}</span>
									</li>
								))}
							</ul>
						</div>
					);
				}}
			</Downshift>
		</div>
	);
}

export default HRSelection;
